const rem = value => `${value / 16}rem`;

export default rem;
